module.exports = __webpack_public_path__ + "img/003-apple.81afc16b.svg";